/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {
  GetAllGroupsForDropDown,
  GetAllFactoriesByGroupID,
  GetOutletByGroupID,
  getModeOfOperation,
  getAvailableCustomerTypes,
  GetProvinceForDropdown,
  GetDistrictForDropdown,
  GetCityForDropdown,
  GetDsDivisionsForDropdown,
  GetGnDivisionsForDropdown,
  SaveCustomerRegistration,
  GetCustomerListingData,
  SearchCustomerByNicOrBrn,
  GetCustomerDetailsByID,
  UpdateCustomerRegistration,
};

async function GetAllGroupsForDropDown() {
  const response = await CommonGet('/api/Group/GetAllGroups', null);
  return response.data;
}

async function GetAllFactoriesByGroupID(groupID) {
  const response = await CommonGet('/api/Factory/GetAllFactoriesByGroupID', 'groupID=' + parseInt(groupID, 10));
  return response.data;
}

async function GetOutletByGroupID(groupID, customerTypeIDs) {
  const ids = Array.isArray(customerTypeIDs) ? customerTypeIDs : [customerTypeIDs];
  const typeParams = ids
    .map((id) => `customerTypeIDs=${parseInt(id, 10)}`)
    .join('&');
  const response = await CommonGet(
    '/api/CustomerMaster/GetOutletByGroupID',
    `groupID=${parseInt(groupID, 10)}&${typeParams}`
  );
  return response.data;
}

async function getModeOfOperation() {
  const response = await CommonGet('/api/CustomerMaster/GetModeOfOperation', null);
  return response.data;
}

async function getAvailableCustomerTypes() {
  const response = await CommonGet('/api/CustomerMaster/GetCustomerTypes', null);
  return response.data;
}

async function GetProvinceForDropdown() {
  const response = await CommonGet('/api/Province/GetAllProvince', null);
  return response.data;
}

async function GetDistrictForDropdown(provinceID) {
  const response = await CommonGet(
    '/api/District/GetAllDistrictByProvinceID',
    `provinceID=${parseInt(provinceID, 10)}`
  );
  return response.data;
}

async function GetCityForDropdown(provinceID, districtID) {
  const response = await CommonGet(
    '/api/City/GetCityByProvinceIDDistrictID',
    `provinceID=${parseInt(provinceID, 10)}&districtID=${parseInt(districtID, 10)}`
  );
  return response.data;
}

async function GetDsDivisionsForDropdown(model) {
  const response = await CommonPost('/api/City/GetDsDivisionsForDropdown', null, model);
  return response.data;
}

async function GetGnDivisionsForDropdown(model) {
  const response = await CommonPost('/api/City/GetGnDivisionsForDropdown', null, model);
  return response.data;
}

async function SaveCustomerRegistration(model) {
  const response = await CommonPost('/api/CustomerMaster/SaveCustomer', null, model);
  return response;
}

async function GetCustomerListingData(groupID, modeID, typeID, status) {
  const model = {
    groupID: parseInt(groupID, 10),
    modeID: parseInt(modeID, 10),
    typeID: parseInt(typeID, 10),
    isActive: parseInt(status, 10)
  };

  const response = await CommonPost('/api/CustomerMaster/GetCustomerListing', null, model);
  return response;
}

async function SearchCustomerByNicOrBrn(groupID, modeID, nicOrBrn) {
  const model = {
    groupID: parseInt(groupID, 10),
    modeID: parseInt(modeID, 10),
    typeID: 0,
    isActive: 2
  };

  const response = await CommonPost('/api/CustomerMaster/GetCustomerListing', null, model);
  const listing = response?.data || [];
  const normalizedSearch = (nicOrBrn || '').toString().trim().toLowerCase();

  const getCandidateValues = (item) => [
    item?.nic,
    item?.NIC,
    item?.businessRegNo,
    item?.BusinessRegNo,
    item?.brn,
    item?.BRN,
    item?.businessRegistrationNo,
    item?.BusinessRegistrationNo,
    item?.nicBrn,
    item?.NicBrn
  ];

  const matchedCustomer = listing.find((x) => {
    const candidates = getCandidateValues(x);
    return candidates.some((value) => (value || '').toString().trim().toLowerCase() === normalizedSearch);
  });

  const customerID = parseInt(
    matchedCustomer?.customerID ?? matchedCustomer?.CustomerID ?? matchedCustomer?.customerId ?? matchedCustomer?.CustomerId,
    10
  );

  if (Number.isNaN(customerID) || customerID <= 0) {
    return null;
  }
  return {
    ...matchedCustomer,
    customerID
  };


}

async function GetCustomerDetailsByID(id, customerName) {
  const queryParts = [`customerID=${parseInt(id, 10)}`];
  if (customerName && customerName.toString().trim() !== '') {
    queryParts.push(`customerName=${encodeURIComponent(customerName.toString().trim())}`);
  }
  const response = await CommonGet('/api/CustomerMaster/GetCustomerDetailsByID', queryParts.join('&'));
  const directPayload = response?.data ?? response?.Data ?? response?.result ?? response?.Result ?? response;
  if (Array.isArray(directPayload)) {
    return directPayload.length > 0 ? directPayload[0] : null;
  }

  if (directPayload && typeof directPayload === 'object') {
    const customerDetails = directPayload.customerDetails ?? directPayload.CustomerDetails
      ?? directPayload.data ?? directPayload.Data
      ?? directPayload.result ?? directPayload.Result;

    const customerTypeDetails = directPayload.customerTypeDetails ?? directPayload.CustomerTypeDetails ?? null;

    if (customerDetails && typeof customerDetails === 'object' && !Array.isArray(customerDetails)) {
      return { ...customerDetails, customerTypeDetails: customerTypeDetails ?? [] };
    }

    if (Array.isArray(customerDetails)) {
      const base = customerDetails.length > 0 ? customerDetails[0] : {};
      return { ...base, customerTypeDetails: customerTypeDetails ?? [] };
    }

    return directPayload;
  }

  return null;
}

async function UpdateCustomerRegistration(model) {
  const response = await CommonPost('/api/CustomerMaster/UpdateCustomer', null, model);
  return response;
}